export default {
  getParams: state => state
};
